import localeHu from '@angular/common/locales/hu';
import { registerLocaleData, DatePipe } from '@angular/common';

registerLocaleData(localeHu);

export function getDateFormatted(format: string, date?: Date): string | null {
   return new DatePipe('hu-HU').transform(date || Date.now(), format);
}
